import React, { useState, useEffect, useCallback } from "react";
import { useNavigate  } from "react-router-dom";
import { useTranslation } from "react-i18next";
// import { useBottomScrollListener } from "react-bottom-scroll-listener";
import Home from "../Home";
import Breadcrumb from "../../components/Breadcrumb";
import { Select } from "antd";
import { Accordion, Card, Spinner } from "react-bootstrap";
import { FRONT_URL } from "../../config/config";
import Maintenance from "../Maintenance";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  fetchSubmissionTypeList,
  fetchOrgCustTypeList,
  fetchPerCustTypeList,
  fetchCustomerTypeList,
  customerRequestStatusInquiry,
} from "./actions";

const checkboxStyle = `
  .custom-checkbox {
    margin-left: 10px;
  }
`;

/*** 
@purpose : Functional component
@Parameter : {props}
**/
function CustomerRequestStatus() {
  const [lang] = useTranslation("language");
  const [showCustomerData, setShowCustomerData] = useState("card card-hide");
  const navigate = useNavigate();
  const [submissionId, setSubmissionId] = useState("");
  const [submissionData, setSubmissionData] = useState("");
  const [submissionType, setSubmissionType] = useState("");
  const [customerTypeId, setCustomerTypeId] = useState("");
  const [unifiedCustomerCode, setUnifiedCustomerCode] = useState("");
  const [kanjiCustomerName, setKanjiCustomerName] = useState("");
  const [kanaCustomerName, setKanaCustomerName] = useState("");
  const [submittedAt, setSubmittedAt] = useState();
  const [submittedAtDate, setSubmittedAtDate] = useState();
  const [wwid, setWWID] = useState("");
  const [totalRequests, setTotalRequests] = useState(0);
  const [loading, setLoading] = useState();
  const [maintenance, setMaintenance] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isTypeLoading, setIsTypeLoading] = useState(false);
  const [noData, setNoData] = useState(false);
  const [limit, setLimit] = useState(40);
  const [errors, setErrors] = useState({});
  const [submissionStatus, setSubmissionStatus] = useState([]);
  const [submissionTypeList, setSubmissionTypeList] = useState([]);
  const [orgCustomerTypeList, setOrgCustomerTypeList] = useState([]);
  const [perCustomerTypeList, setPerCustomerTypeList] = useState([]);
  const [customerTypeList, setCustomerTypeList] = useState([]);
  const [requestInquiryList, setRequestInquiryList] = useState([]);

  const [sortCode, setSortCode] = useState("asc");
  const [sortKanjiName, setSortKanjiName] = useState("asc");
  const [sortSubmissionId, setSortSubmissionId] = useState("asc");
  const [sortSubmissionData, setSortSubmissionData] = useState("asc");
  const [sortSubmissionType, setSortSubmissionType] = useState("asc");
  const [sortSubmissionStatus, setSortSubmissionStatus] = useState("asc");
  const [sortCustomerType, setSortCustomerType] = useState("asc");
  const [sortSubmittedBy, setSortSubmittedBy] = useState("asc");
  const [sortSubmittedAt, setSortSubmittedAt] = useState("asc");
  const [lazyLoading, setLazyLoading] = useState(false);

  const routes = [
    {
      name: `${lang("Menu.home")}`,
      path: "/",
    },
    {
      name: `${lang("Menu.customerRequestStatus")}`,
      path: "/customerRequestStatus",
    },
  ];

  const submissionDataOptions = [
    { value: "organization_customer", label: "施設" },
    { value: "person_customer", label: "医師(薬剤師)" },
    { value: "customer_affiliation", label: "医師(薬剤師)勤務先" },
  ];

  useEffect(() => {
    getOrgClassification();
    getPersonClassification();
    getCustomerTypeList();
  }, []);

  /*** 
  @purpose : handle lazy loading
  @Parameter : {}
  **/
  const handleContainerOnBottom = useCallback(async () => {
    let body = {
      submission_id: submissionId,
      submission_data: submissionData,
      submission_type: submissionType,
      customer_type: customerTypeId,
      unified_customer_code: unifiedCustomerCode,
      customer_name_kanji: kanjiCustomerName,
      customer_name_kana: kanaCustomerName,
      submitted_at: submittedAt,
      submission_status: submissionStatus,
      submitted_by: wwid,
      limit: requestInquiryList.length,
      totalRecords: totalRequests,
    };
    if (requestInquiryList.length < totalRequests) {
      await customerRequestStatusInquiry(body).then((response) => {
        let list = [];
        list = requestInquiryList.concat(response.data);
        setRequestInquiryList(list);
      });
      setLimit(limit + 10);
    }
  }, [requestInquiryList, limit, totalRequests]);

  // const containerRef = useBottomScrollListener(handleContainerOnBottom);

  /*** 
  @purpose : Get org classification list
  @Parameter : {}
  **/
  const getOrgClassification = async () => {
    await fetchOrgCustTypeList().then((res) => {
      let newList = [];
      for (let index = 0; index < res.length; index++) {
        const item = res[index];
        newList.push({
          value: item.custTypeID,
          label: item.customerTypeNameLocal,
        });
      }
      setOrgCustomerTypeList(newList);
    });
  };

  /*** 
  @purpose : Get person classification list
  @Parameter : {}
  **/
  const getPersonClassification = async () => {
    await fetchPerCustTypeList().then((res) => {
      let newList = [];
      for (let index = 0; index < res.length; index++) {
        const item = res[index];
        newList.push({
          value: item.custTypeID,
          label: item.customerTypeNameLocal,
        });
      }
      setPerCustomerTypeList(newList);
    });
  };

  /*** 
  @purpose : Get customer type list
  @Parameter : {props}
  **/
  const getCustomerTypeList = async () => {
    await fetchCustomerTypeList().then((response) => {
      if(response && response.data.maintenanceWindowFlag) {
        setMaintenance(true)
      }
      let res = response.data.data
      let data = [];
      let obj = {};
      for (var property in res) {
        var n = property;
        obj = { label: n, options: res[n] };
        data.push(obj);
      }
      let newList = [];
      for (let i = 0; i < data.length; i++) {
        let list = [];
        for (let index = 0; index < data[i].options.length; index++) {
          const item = data[i].options[index];
          list.push({
            value: item.custTypeID,
            label: item.customerTypeNameLocal,
          });
        }
        newList.push({ label: data[i].label, options: list });
      }
      setCustomerTypeList(newList);
    });
  };

  /*** 
  @purpose : Validate customer request status inquiry form
  @Parameter : {}
  **/
  const validateForm = () => {
    let isFormValid = true;
    let pattern = new RegExp(/[<.|\n*?>]/);
    let kanaRegex = new RegExp(/^[ｦ-ﾟ -~]+$/);
    let errors = {
      kanjiCustomerName: "",
      kanaCustomerName: "",
    };

    if (kanjiCustomerName && pattern.test(kanjiCustomerName) === true)
      errors.kanjiCustomerName = "errorMessages.VALID_KANJI_CUSTOMER_NAME";
    else errors.kanjiCustomerName = "";

    if (kanaCustomerName && kanaRegex.test(kanaCustomerName) === false)
      errors.kanaCustomerName = "errorMessages.VALID_KANA_CUSTOMER_NAME";
    else errors.kanaCustomerName = "";

    if (errors.kanjiCustomerName !== "" || errors.kanaCustomerName !== "") {
      isFormValid = false;
    } else {
      isFormValid = true;
    }
    setErrors(errors);

    return isFormValid;
  };

  /*** 
  @purpose : Handle customer request status
  @Parameter : {props}
  **/
  const handleCustomerRequestStatus = async () => {
    if (validateForm()) {
      setIsLoading(true);
      setShowCustomerData("card card-show");
      setNoData(false);
      let body = {
        submission_id: submissionId,
        submission_data: submissionData,
        submission_type: submissionType,
        customer_type: customerTypeId,
        unified_customer_code: unifiedCustomerCode,
        customer_name_kanji: kanjiCustomerName,
        customer_name_kana: kanaCustomerName,
        submitted_at: submittedAt && submittedAt.replaceAll("/", "-"),
        submission_status: submissionStatus,
        submitted_by: wwid,
        limit: 0,
        totalRecords: 0,
      };

      await customerRequestStatusInquiry(body).then((response) => {
        if(response.maintenanceWindowFlag) {
          setMaintenance(true)
        } else {
        if (response.success === true && response.data.length > 0) {
          setIsLoading(false);
          setLoading(false);
          var result =
            response &&
            response.data.map(function (el) {
              var o = Object.assign({}, el);

              o.submission_id = o.submission_id.toString();
              return o;
            });
          setRequestInquiryList(result);
          setTotalRequests(response.total);
          setNoData(false);
        }
        if (response.success === true && response.data.length === 0) {
          setIsLoading(false);
          setLoading(false);
          setNoData(true);
          setRequestInquiryList([]);
        }
        }
      });
    }
  };

  /*** 
  @purpose : Handle request status
  @Parameter : {request}
  **/
  const handleRequestStatus = (request) => {
    if (request.data === "施設") {
      // navigate(`/organizationCustomerDetails?reqId=${request.id}`);
      window.open(FRONT_URL + `/organizationCustomerDetails?reqId=${request.id}`, "_blank")
    } else if (request.data === "医師(薬剤師)") {
      // navigate(`/personCustomerDetails?reqId=${request.id}`);
      window.open(FRONT_URL + `/personCustomerDetails?reqId=${request.id}`, "_blank")
    } else if (request.data === "医師(薬剤師)勤務先") {
      // navigate(`/affiliationDetails?reqId=${request.id}`);
      window.open(FRONT_URL + `/affiliationDetails?reqId=${request.id}`, "_blank")
    }
  };

  /*** 
  @purpose : Handle submission data
  @Parameter : {value}
  **/
  const handleSubmissionData = async (value) => {
    if (value) {
      setIsTypeLoading(true);
      setCustomerTypeList([]);
      setSubmissionData(value.value);
      if (value.label === "施設") {
        setCustomerTypeList(orgCustomerTypeList);
      }
      if (value.label === "医師(薬剤師)") {
        setCustomerTypeList(perCustomerTypeList);
      }
      let body = {
        data: value.value,
      };
      await fetchSubmissionTypeList(body).then((response) => {
        setIsTypeLoading(false);
        let newList = [];
        for (let index = 0; index < response.length; index++) {
          const item = response[index];
          newList.push({
            value: item.key,
            label: item.value,
          });
        }
        setSubmissionTypeList(newList);
      });
    } else {
      setIsTypeLoading(false);
      setSubmissionData("");
    }
  };

  /*** 
  @purpose : Handle submission type
  @Parameter : {value}
  **/
  const handleSubmissionType = (value) => {
    if (value) {
      setSubmissionType(value.value);
    } else {
      setSubmissionType("");
    }
  };

  /*** 
  @purpose : Handle customer type
  @Parameter : {value}
  **/
  const handleCustomerType = (value) => {
    if (value) {
      setCustomerTypeId(value.value);
    } else {
      setCustomerTypeId("");
    }
  };

  /*** 
  @purpose : Handle submitted at
  @Parameter : {date}
  **/
  const handleSubmittedAt = (date) => {
    if (date) {
      setSubmittedAtDate(date)
      var fullDate = new Date(date),
        mnth = ("0" + (date.getMonth() + 1)).slice(-2),
        day = ("0" + date.getDate()).slice(-2);
      var dt = [fullDate.getFullYear(), mnth].join("");
      setSubmittedAt([fullDate.getFullYear(), mnth].join("/"));
    } else {
      setSubmittedAtDate();
      setSubmittedAt();
    }
  };

  /*** 
  @purpose : Handle submission status
  @Parameter : {e}
  **/
  const handleSubmissionStatus = (e) => {
    let list = [];
    if (e.target.checked === true) {
      list = [...submissionStatus, e.target.value];
    } else {
      list = submissionStatus.filter((s) => s !== e.target.value);
    }
    setSubmissionStatus(list);
  };

  /*** 
  @purpose : Handle sorting
  @Parameter : {}
  **/
  const handleSortingData = (obj) => {
    obj.column === "submission_id" && setSortSubmissionId(obj.sortOrder);
    obj.column === "submission_data" && setSortSubmissionData(obj.sortOrder);
    obj.column === "submission_type" && setSortSubmissionType(obj.sortOrder);
    obj.column === "unified_customer_code" && setSortCode(obj.sortOrder);
    obj.column === "customer_type_name" && setSortCustomerType(obj.sortOrder);
    obj.column === "name_kanji" && setSortKanjiName(obj.sortOrder);
    obj.column === "submission_status" &&
      setSortSubmissionStatus(obj.sortOrder);
    obj.column === "submitted_by" && setSortSubmittedBy(obj.sortOrder);
    obj.column === "submitted_at" && setSortSubmittedAt(obj.sortOrder);
    let list = compareBySortedData(obj);
    setRequestInquiryList(list);
  };

  const compareBySortedData = (obj) => {
    const sorted = requestInquiryList.sort((a, b) => {
      const isReversed = obj.sortOrder === "asc" ? 1 : -1;
      let first = a[obj.column] ? a[obj.column] : "";
      let second = b[obj.column] ? b[obj.column] : "";
      return isReversed * first.localeCompare(second);
    });
    return sorted;
  };

  const loadRecords = async () => {
    setLazyLoading(true);
    let body = {
      submission_id: submissionId,
      submission_data: submissionData,
      submission_type: submissionType,
      customer_type: customerTypeId,
      unified_customer_code: unifiedCustomerCode,
      customer_name_kanji: kanjiCustomerName,
      customer_name_kana: kanaCustomerName,
      submitted_at: submittedAt && submittedAt.replaceAll("/", "-"),
      submission_status: submissionStatus,
      submitted_by: wwid,
      limit: requestInquiryList.length,
      totalRecords: totalRequests,
    };
    setLazyLoading(false);
    if (requestInquiryList.length < totalRequests) {
      await customerRequestStatusInquiry(body).then((response) => {
        let list = [];
        list = requestInquiryList.concat(response.data);
        setRequestInquiryList(list);
      });
      setLimit(limit + 10);
    }
  };

  const [text, setText] = useState({})
  const [language, setLang] = useState({})

  useEffect(() => {
    if(sessionStorage.getItem("translation")){
      setText(JSON.parse(sessionStorage.getItem("translation")))
    }
    if(sessionStorage.getItem("translation")){
      setLang(sessionStorage.getItem("Language"))
    }
  }, [sessionStorage.getItem("Language")]);

  const [finalText, setfinalText] = useState('')
  const [finalText2, setfinalText2] = useState("");
  useEffect(() => {
    const searchText = "notice_dcr";
    const filteredTexts2 = {};
    const searchText2 = "commonmessage";
    const filteredTexts = {};
    for (const key in text) {
      if (key.includes(searchText)) {
        if (key.endsWith('_en') || key.endsWith('_ja')) {
          const langKey = key.includes("_en") ? "en" : "jp";
          const value = text[key];
          filteredTexts[langKey] = value;
        }
      }
    }
    for (const key in text) {
      if (key.includes(searchText2)) {
        if (key.endsWith('_en') || key.endsWith('_ja')) {
          const langKey = key.includes("_en") ? "en" : "jp";
          const value = text[key];
          filteredTexts2[langKey] = value;
        }
      }
    }
    if(filteredTexts[language]){
      setfinalText(filteredTexts[language])
    }
    if (filteredTexts2[language]) {
      setfinalText2(filteredTexts2[language]);
    }

  }, [language,text]);

  return (
    <Home>
      <style>{checkboxStyle}</style>
      
      {maintenance ? (
      <Maintenance />) :(
      <> 
      <Breadcrumb finalText={finalText} finalText2={finalText2} routes={routes} />
      <h2>{lang("Menu.customerRequestStatus")}</h2>

      <Accordion defaultActiveKey="0" className="shadow-accordion">
        <Accordion.Item eventKey="0">
          <Accordion.Header>
            {lang("customerRequestStatus.searchCondition")}
          </Accordion.Header>
          <Accordion.Body>
            <div className="horizon-form-lg">
              <div className="horizon-form">
                <div className="custom-3">
                  <label>{lang("organizationDetails.submissionID")}</label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      value={submissionId}
                      onChange={(e) => setSubmissionId(e.target.value)}
                    />
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>
                    {lang("customerRequestStatus.submissionData")}
                  </label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <Select
                      className="ant-select"
                      options={submissionDataOptions}
                      placeholder={lang(
                        "customerRequestStatus.submissionData"
                      )}
                      allowClear={true}
                      showSearch={
                        submissionDataOptions &&
                          submissionDataOptions.length > 0
                          ? true
                          : false
                      }
                      optionFilterProp="label"
                      labelInValue={true}
                      onChange={handleSubmissionData}
                    />
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>
                    {lang("customerRequestStatus.submissionType")}
                  </label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <Select
                      className="ant-select"
                      options={submissionTypeList}
                      placeholder={lang(
                        "customerRequestStatus.submissionType"
                      )}
                      onChange={handleSubmissionType}
                      allowClear={true}
                      loading={isTypeLoading}
                      showSearch={
                        submissionTypeList && submissionTypeList.length > 0
                          ? true
                          : false
                      }
                      optionFilterProp="label"
                      labelInValue={true}
                      disabled={submissionData ? false : true}
                    />
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>{lang("organizationDetails.customerType")}</label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <Select
                      className="ant-select"
                      options={customerTypeList}
                      placeholder={lang("organizationDetails.customerType")}
                      allowClear={true}
                      showSearch={
                        customerTypeList && customerTypeList.length > 0
                          ? true
                          : false
                      }
                      optionFilterProp="label"
                      labelInValue={true}
                      onChange={handleCustomerType}
                    />
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>
                    {lang("organizationDetails.unifiedCustomerCode")}
                  </label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      value={unifiedCustomerCode}
                      onChange={(e) => setUnifiedCustomerCode(e.target.value)}
                    />
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>
                    {lang("organizationDetails.kanjiCustomerName")}
                  </label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      value={kanjiCustomerName}
                      maxLength="100"
                      onChange={(e) => setKanjiCustomerName(e.target.value)}
                    />
                    {errors.kanjiCustomerName && (
                      <p className="error-text">
                        {lang(`${errors.kanjiCustomerName}`)}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>
                    {lang("organizationDetails.kanaCustomerName")}
                  </label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      value={kanaCustomerName}
                      maxLength="100"
                      onChange={(e) => setKanaCustomerName(e.target.value)}
                    />
                    {errors.kanaCustomerName && (
                      <p className="error-text">
                        {lang(`${errors.kanaCustomerName}`)}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>{lang("customerRequestStatus.submittedAt")}</label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <DatePicker
                      selected={submittedAtDate}
                      value={submittedAt}
                      showMonthYearPicker={true}
                      className="form-control"
                      onChange={(date) => handleSubmittedAt(date)}
                      style={{ display: "block" }}
                      isClearable = {true}
                    />
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>
                    {lang("customerRequestStatus.submittedBy")}(WWID)
                  </label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      value={wwid}
                      onChange={(e) => setWWID(e.target.value)}
                    />
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>
                    {lang("customerRequestStatus.submissionStatus")}
                  </label>
                </div>
                  <div className="custom-9 mt-3">
                      <div className="custom-checkbox d-inline-block mr-3 mb-2">
                          <input
                              type="checkbox"
                              id="status1"
                              name="status"
                              value="1"
                              onChange={(e) => handleSubmissionStatus(e)}
                          />
                          <label htmlFor="status1">
                              {lang("customerRequestStatus.submitted")}
                          </label>
                      </div>
                      <div className="custom-checkbox d-inline-block mr-3 mb-2">
                          <input
                              type="checkbox"
                              id="status2"
                              name="status"
                              value="2"
                              onChange={(e) => handleSubmissionStatus(e)}
                          />
                          <label htmlFor="status2">
                              {lang("customerRequestStatus.sentToUltmarc")}
                          </label>
                      </div>
                      <div className="custom-checkbox d-inline-block mr-3 mb-2">
                          <input
                              type="checkbox"
                              id="status3"
                              name="status"
                              value="4"
                              onChange={(e) => handleSubmissionStatus(e)}
                          />
                          <label htmlFor="status3">
                              {lang("customerRequestStatus.acceptedByUltmarc")}
                          </label>
                      </div>
                      <div className="custom-checkbox d-inline-block mr-3 mb-2">
                          <input
                              type="checkbox"
                              id="status4"
                              name="status"
                              value="3"
                              onChange={(e) => handleSubmissionStatus(e)}
                          />
                          <label htmlFor="status4">
                              {lang("customerRequestStatus.rejectedByUltmarc")}
                          </label>
                      </div>
                      <div className="custom-checkbox d-inline-block mr-3 mb-2">
                          <input
                              type="checkbox"
                              id="status7"
                              name="status"
                              value="7"
                              onChange={(e) => handleSubmissionStatus(e)}
                          />
                          <label htmlFor="status7">
                              {lang("customerRequestStatus.onHoldByUltmarc")}
                          </label>
                      </div>
                      <div className="custom-checkbox d-inline-block mr-3 mb-2">
                          <input
                              type="checkbox"
                              id="status5"
                              name="status"
                              value="5"
                              onChange={(e) => handleSubmissionStatus(e)}
                          />
                          <label htmlFor="status5">
                              {lang(
                                  "customerRequestStatus.reflectedToCustomerMaster"
                              )}
                          </label>
                      </div>

                      <div className="custom-checkbox d-inline-block mr-3 mb-2">
                          <input
                              type="checkbox"
                              id="status8"
                              name="status"
                              value="8"
                              onChange={(e) => handleSubmissionStatus(e)}
                          />
                          <label htmlFor="status8">
                              {lang("customerRequestStatus.resubmitted")}
                          </label>
                      </div>

                      <div className="custom-checkbox d-inline-block mr-3 mb-2">
                          <input
                              type="checkbox"
                              id="status6"
                              name="status"
                              value="6"
                              onChange={(e) => handleSubmissionStatus(e)}
                          />
                          <label htmlFor="status6">
                              {lang("customerRequestStatus.cancelled")}
                          </label>
                      </div>

                      <div className="steps-action1 mt-2">
                          {isLoading && <Spinner animation="border"/>}
                          <button
                              className="btn btn-primary"
                              onClick={handleCustomerRequestStatus}
                              disabled={isLoading}
                          >
                              {lang("Buttons.search")}
                          </button>
                      </div>
                  </div>
              </div>
            </div>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>

          {requestInquiryList && requestInquiryList.length > 0 && (
              <p className="record-total">
                  {lang("territoryDefinitionMaintenance.totalRecords")} -{" "}
                  {requestInquiryList.length} / {totalRequests}
              </p>
          )}
          {requestInquiryList && requestInquiryList.length > 0 && (
              <>
                  <div
                      // ref={containerRef}
                      className="table-responsive max-height mb-0 hover-table"
                  >
                      <table className="table" aria-describedby="table">
                          <thead>
                          <tr>
                              <th scope="col">
                                  <div className="cursor-pointer">
                                      {lang("organizationDetails.submissionID")}
                      <em
                        className="bx bxs-sort-alt"
                        onClick={() =>
                          handleSortingData({
                            column: "submission_id",
                            sortOrder:
                              sortSubmissionId === "desc" ? "asc" : "desc",
                          })
                        }
                      ></em>
                    </div>
                  </th>
                  <th scope="col">
                    <div className="cursor-pointer">
                      {lang("customerRequestStatus.submissionData")}
                      <em
                        className="bx bxs-sort-alt"
                        onClick={() =>
                          handleSortingData({
                            column: "submission_data",
                            sortOrder:
                              sortSubmissionData === "desc" ? "asc" : "desc",
                          })
                        }
                      ></em>
                    </div>
                  </th>
                  <th scope="col">
                    <div className="cursor-pointer">
                      {lang("customerRequestStatus.submissionType")}
                      <em
                        className="bx bxs-sort-alt"
                        onClick={() =>
                          handleSortingData({
                            column: "submission_type",
                            sortOrder:
                              sortSubmissionType === "desc" ? "asc" : "desc",
                          })
                        }
                      ></em>
                    </div>
                  </th>
                  <th scope="col">
                    <div className="cursor-pointer">
                      {lang("organizationDetails.unifiedCustomerCode")}
                      <em
                        className="bx bxs-sort-alt"
                        onClick={() =>
                          handleSortingData({
                            column: "unified_customer_code",
                            sortOrder: sortCode === "desc" ? "asc" : "desc",
                          })
                        }
                      ></em>
                    </div>
                  </th>
                  <th scope="col">
                    <div className="cursor-pointer">
                      {lang("organizationDetails.customerType")}
                      <em
                        className="bx bxs-sort-alt"
                        onClick={() =>
                          handleSortingData({
                            column: "customer_type_name",
                            sortOrder:
                              sortCustomerType === "desc" ? "asc" : "desc",
                          })
                        }
                      ></em>
                    </div>
                  </th>
                  <th scope="col">
                    <div className="cursor-pointer">
                      {lang("organizationDetails.customerName")}
                      <em
                        className="bx bxs-sort-alt"
                        onClick={() =>
                          handleSortingData({
                            column: "name_kanji",
                            sortOrder: sortKanjiName === "desc" ? "asc" : "desc",
                          })
                        }
                      ></em>
                    </div>
                  </th>
                  <th scope="col">
                    <div className="cursor-pointer">
                      {lang("parentChildChangeRequest.status")}
                      <em
                        className="bx bxs-sort-alt"
                        onClick={() =>
                          handleSortingData({
                            column: "submission_status",
                            sortOrder:
                              sortSubmissionStatus === "desc" ? "asc" : "desc",
                          })
                        }
                      ></em>
                    </div>
                  </th>
                  <th scope="col">
                    <div className="cursor-pointer">
                      {lang("parentChildChangeRequest.submittedBy")}
                      <em
                        className="bx bxs-sort-alt"
                        onClick={() =>
                          handleSortingData({
                            column: "submitted_by",
                            sortOrder:
                              sortSubmittedBy === "desc" ? "asc" : "desc",
                          })
                        }
                      ></em>
                    </div>
                  </th>
                  <th scope="col">
                    <div className="cursor-pointer">
                      {lang("organizationDetails.requesterName")}
                      <em
                        className="bx bxs-sort-alt"
                        onClick={() =>
                          handleSortingData({
                            column: "submitted_by",
                            sortOrder:
                              sortSubmittedBy === "desc" ? "asc" : "desc",
                          })
                        }
                      ></em>
                    </div>
                  </th>
                  <th scope="col">
                    <div className="cursor-pointer">
                      {lang("parentChildChangeRequest.submittedAt")}
                      <em
                        className="bx bxs-sort-alt"
                        onClick={() =>
                          handleSortingData({
                            column: "submitted_at",
                            sortOrder:
                              sortSubmittedAt === "desc" ? "asc" : "desc",
                          })
                        }
                      ></em>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {requestInquiryList &&
                  requestInquiryList.map((req) => {
                    return (
                      <tr
                        key={req.submission_id}
                        onClick={() =>
                          handleRequestStatus({
                            data: req.submission_data,
                            type: req.submission_type,
                            id: req.submission_id,
                          })
                        }
                      >
                        <td>{req.submission_id}</td>
                        <td>{req.submission_data}</td>
                        <td>{req.submission_type}</td>
                        <td>{req.unified_customer_code}</td>
                        <td>{req.customer_type_name}</td>
                        <td>{req.name_kanji}</td>
                        <td>{req.submission_status}</td>
                        <td>{req.submitted_by}</td>
                        <td>{req.requester_name}</td>
                        <td>{req.submitted_at}</td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
          {requestInquiryList.length < totalRequests && (
            <div className="steps-action1 mt-4">
              {lazyLoading && <Spinner animation="border" />}
              <button
                className="btn btn-primary"
                onClick={loadRecords}
                disabled={lazyLoading}

              >
                {lang("Buttons.loadMore")}
              </button>
            </div>
          )}
        </>
      )}
      {loading === true && (
        <Spinner animation="border" />
      )}
      {/* {requestInquiryList.length === 0 && loading === true && (
        <Spinner animation="border" />
      )} */}
      {noData && <div className="noData">{lang("errorMessages.NO_DATA")}</div>}
      {/* </>
      }  */}
    </>
    )}</Home>
  );
}

export default CustomerRequestStatus;
